import { KeyValueModel } from "model";
import { EnumUploadCargaTipo } from "model/enums/enum-upload-carga-tipo";

export const TpUploadCargaTipoMock: KeyValueModel[] = [
    new KeyValueModel(EnumUploadCargaTipo.PESSOA, "Pessoas"),
    new KeyValueModel(EnumUploadCargaTipo.PRODUTO, "Produtos"),
];
